var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36ZM16.5509 8.77686H19.4492L19.4491 16.551L27.2237 16.5511V19.4491H19.449L19.4489 27.2233H16.5509V19.4491H8.77734V16.5508L16.5509 16.5509V8.77686Z",
    fill: "#BEC0C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBubble);
export default __webpack_public_path__ + "static/media/plus_bubble.9dea209d8aaed7f49a4d7538bf01d04e.svg";
export { ForwardRef as ReactComponent };